import React, { useState } from 'react';
import Layout from '../components/Layout';

function GradingEngineConfig({ user, onLogout }) {
  const [grades, setGrades] = useState([
    { name: 'Grade A', minScore: 90, maxScore: 100, color: 'green' },
    { name: 'Grade B', minScore: 70, maxScore: 89, color: 'blue' },
    { name: 'Grade C', minScore: 50, maxScore: 69, color: 'yellow' },
    { name: 'Grade D', minScore: 0, maxScore: 49, color: 'red' },
  ]);

  const [parameters, setParameters] = useState([
    { name: 'Screen Condition', weight: 25 },
    { name: 'Battery Health', weight: 20 },
    { name: 'Body Condition', weight: 15 },
    { name: 'Camera Function', weight: 15 },
    { name: 'Audio Quality', weight: 10 },
    { name: 'Network/Wifi', weight: 10 },
    { name: 'Other', weight: 5 },
  ]);

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Grading Engine Configuration</h1>
          <p className="text-gray-600 mt-2">Configure grades and QC parameters</p>
        </div>

        {/* Grade Configuration */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">Grade Definitions</h2>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
              + Add Grade
            </button>
          </div>

          <div className="space-y-4">
            {grades.map((grade, index) => (
              <div key={index} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                <div className="flex-1">
                  <input
                    type="text"
                    value={grade.name}
                    onChange={(e) => {
                      const updated = [...grades];
                      updated[index].name = e.target.value;
                      setGrades(updated);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    value={grade.minScore}
                    onChange={(e) => {
                      const updated = [...grades];
                      updated[index].minScore = parseInt(e.target.value);
                      setGrades(updated);
                    }}
                    className="w-20 px-3 py-2 border border-gray-300 rounded-md"
                  />
                  <span>-</span>
                  <input
                    type="number"
                    value={grade.maxScore}
                    onChange={(e) => {
                      const updated = [...grades];
                      updated[index].maxScore = parseInt(e.target.value);
                      setGrades(updated);
                    }}
                    className="w-20 px-3 py-2 border border-gray-300 rounded-md"
                  />
                </div>
                <button className="text-red-600 hover:text-red-800">Delete</button>
              </div>
            ))}
          </div>
        </div>

        {/* Parameter Configuration */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">QC Parameters</h2>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
              + Add Parameter
            </button>
          </div>

          <div className="space-y-4">
            {parameters.map((param, index) => (
              <div key={index} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                <div className="flex-1">
                  <input
                    type="text"
                    value={param.name}
                    onChange={(e) => {
                      const updated = [...parameters];
                      updated[index].name = e.target.value;
                      setParameters(updated);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <label className="text-sm text-gray-600">Weight:</label>
                  <input
                    type="number"
                    value={param.weight}
                    onChange={(e) => {
                      const updated = [...parameters];
                      updated[index].weight = parseInt(e.target.value);
                      setParameters(updated);
                    }}
                    className="w-20 px-3 py-2 border border-gray-300 rounded-md"
                  />
                  <span>%</span>
                </div>
                <button className="text-red-600 hover:text-red-800">Delete</button>
              </div>
            ))}
          </div>

          <div className="mt-4 p-4 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              Total Weight: {parameters.reduce((sum, p) => sum + p.weight, 0)}%
              {parameters.reduce((sum, p) => sum + p.weight, 0) !== 100 && (
                <span className="ml-2 text-red-600 font-semibold">(Must equal 100%)</span>
              )}
            </p>
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-6">
          <button className="w-full px-4 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold">
            Save Configuration
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default GradingEngineConfig;
